export const getFilterTaxonomy = (el) => el.getAttribute('data-taxonomy') || '';
